import { useEffect } from 'react';

import { useAuth } from 'react-oidc-context';

import { useGetUserMe } from '@/api/REST/userMe';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { isTest } from '@/legacy/utils/env';

export const useHasNewNavigation = (): boolean => {
  const { hasLegacyBillingPlan, isLoading } = useGetUserMe();
  const { user } = useAuth();

  const storageKey = user?.profile.sub
    ? `hasNewNavigation:${user.profile.sub}`
    : null;
  const [cachedValue, setCachedValue] = useLocalStorage<boolean | null>(
    storageKey,
    null,
  );

  useEffect(() => {
    if (!isLoading) {
      setCachedValue(!hasLegacyBillingPlan && !isTest);
    }
  }, [isLoading, hasLegacyBillingPlan, setCachedValue]);

  if (isLoading) {
    return cachedValue ?? false;
  }

  return !hasLegacyBillingPlan && !isTest;
};
